export enum timeRangeCategoryTypeEnum {
  TimeSettingsCustomTimeRangeCategory = 'TimeSettings::CustomTimeRangeCategory',
  AttendanceCustomTimeRangeCategory = 'Attendance::CustomTimeRangeCategory',
}

export enum OVERNIGHT_SHIFTS_CALCULATION_METHODS {
  beginning_shift = 'beginning_shift',
  calendar_day = 'calendar_day',
}

export type STATUS = 'pending' | 'approved' | 'rejected'

export enum CAPACITY_UNITS {
  hours = 'hours',
  minutes = 'minutes',
}

export enum UPDATE_FREQUENCY {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
}

export enum NEGATIVE_TRANSFERS {
  none = 'none',
  limited = 'limited',
  unlimited = 'unlimited',
}

// Extra hour rules baseline for type safety in UI
export type EXTRA_HOURS_RANGE_BASELINE = 'contract_hours' | 'effective_hours'
